import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { StoryIF } from '@/components/cards/StoriesCard/StoryCard.types';

interface StoriesStateIF {
    storiesMap: Record<string, StoryIF>;
    currentIndex: number;
    progress: number;
}

const initialState: StoriesStateIF = {
    storiesMap: {},
    currentIndex: 0,
    progress: 0,
};

const storiesSlice = createSlice({
    name: 'stories',
    initialState,
    reducers: {
        setStoriesMap: (
            state,
            action: PayloadAction<Record<string, StoryIF>>,
        ) => {
            state.storiesMap = action.payload;
        },
        setCurrentIndex: (state, action: PayloadAction<number>) => {
            state.currentIndex = action.payload;
        },
        setProgress: (state, action: PayloadAction<number>) => {
            state.progress = action.payload;
        },
        resetStories: (state) => {
            state.currentIndex = 0;
            state.progress = 0;
        },
    },
});

export const { setStoriesMap, setCurrentIndex, setProgress, resetStories } =
    storiesSlice.actions;

storiesSlice.reducerPath = 'stories';

export const storiesReducer = storiesSlice.reducer;
export { storiesSlice };
